import { ModalProvider } from './context/ModalContext';
import { HelmetProvider } from 'react-helmet-async';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import AppRoutes from './routes/AppRoutes';
import styles from './App.module.css';

function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <ModalProvider>
          <div className={styles.app}>
            <AppRoutes />
          </div>
        </ModalProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
}

export default App;
